<template>
  <span
    class="tw-size-1 tw-inline-block tw-rounded-full tw-bg-[var(--tile-text)] tw-opacity-50"
    :class="`tw-ml-${margin}`"
  />
</template>

<script>
export default {
  props: {
    margin: {
      type: String,
      default: '2',
    },
  },
}
</script>
